export default {"src":"/_next/static/media/rating-3.1e41189e.svg","height":96,"width":512,"blurWidth":0,"blurHeight":0};